// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .accountDataGrid .css-axafay-MuiDataGrid-virtualScroller {
  max-height: 300px !important;
} */

.css-5wly58-MuiDataGrid-root .MuiDataGrid-row--editing .MuiDataGrid-cell {
  box-shadow: none;
  color: white !important;
  background-color: #282b30 !important;
}

.css-15fttl9-MuiDataGrid-root .MuiDataGrid-row--editing .MuiDataGrid-cell {
  background-color: #282b30 !important;
}

.css-1b74o31-MuiInputBase-root-MuiDataGrid-editInputCell {
  color: white !important;
}

/* Styling input when data grid edit mode */
.accountDataGrid .MuiInputBase-input {
  padding: 5px 0 5px 5px !important;
  margin-left: 5px !important;
  border: none !important;
  border-bottom: 1px solid gray !important;
}

.accountDataGrid .MuiDataGrid-root .MuiDataGrid-cell:focus-within {
  outline: none !important;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
  border: none !important;
  padding-right: 32px !important;
}

.MuiDataGrid-iconButtonContainer button {
  background-color: #282b30 !important;
}

.MuiDataGrid-menuIcon button {
  background-color: #282b30 !important;
}

.MuiDataGrid-iconButtonContainer button:hover {
  background-color: #282b30 !important;
}

.MuiDataGrid-menuIcon button:hover {
  background-color: #282b30 !important;
}

.css-zylse7-MuiButtonBase-root-MuiIconButton-root {
  background-color: #282b30 !important;
}

.css-rtrcn9-MuiTablePagination-root {
  margin: 0px !important;
}

.css-axafay-MuiDataGrid-virtualScroller {
  height: max-content;
  max-height: 500px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/DataGrid/DataGridContainer.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B","sourcesContent":["/* .accountDataGrid .css-axafay-MuiDataGrid-virtualScroller {\n  max-height: 300px !important;\n} */\n\n.css-5wly58-MuiDataGrid-root .MuiDataGrid-row--editing .MuiDataGrid-cell {\n  box-shadow: none;\n  color: white !important;\n  background-color: #282b30 !important;\n}\n\n.css-15fttl9-MuiDataGrid-root .MuiDataGrid-row--editing .MuiDataGrid-cell {\n  background-color: #282b30 !important;\n}\n\n.css-1b74o31-MuiInputBase-root-MuiDataGrid-editInputCell {\n  color: white !important;\n}\n\n/* Styling input when data grid edit mode */\n.accountDataGrid .MuiInputBase-input {\n  padding: 5px 0 5px 5px !important;\n  margin-left: 5px !important;\n  border: none !important;\n  border-bottom: 1px solid gray !important;\n}\n\n.accountDataGrid .MuiDataGrid-root .MuiDataGrid-cell:focus-within {\n  outline: none !important;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {\n  border: none !important;\n  padding-right: 32px !important;\n}\n\n.MuiDataGrid-iconButtonContainer button {\n  background-color: #282b30 !important;\n}\n\n.MuiDataGrid-menuIcon button {\n  background-color: #282b30 !important;\n}\n\n.MuiDataGrid-iconButtonContainer button:hover {\n  background-color: #282b30 !important;\n}\n\n.MuiDataGrid-menuIcon button:hover {\n  background-color: #282b30 !important;\n}\n\n.css-zylse7-MuiButtonBase-root-MuiIconButton-root {\n  background-color: #282b30 !important;\n}\n\n.css-rtrcn9-MuiTablePagination-root {\n  margin: 0px !important;\n}\n\n.css-axafay-MuiDataGrid-virtualScroller {\n  height: max-content;\n  max-height: 500px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
